import React, { useCallback, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import clsx from "clsx";

type ShinyCardProps = {
  sweep?: number;
  children?: React.ReactNode;
  className?: string;
};

export default function ShinyCard({
  sweep = 1.1,
  children,
  className,
}: ShinyCardProps) {
  const reduce = useReducedMotion();
  const [shineKey, setShineKey] = useState(0);
  const [armed, setArmed] = useState(false); // evita que aparezca algo al cargar

  const onEnter = useCallback(() => {
    if (reduce) return;
    setArmed(true);
    setShineKey((k) => k + 1); // remonta el overlay y re-ejecuta animación
  }, [reduce]);

  return (
    <div
      className={clsx([
        "relative",
        "overflow-hidden",
        "rounded",
        "h-full",
        ...(className ? [className] : []),
      ])}
      onMouseEnter={onEnter}
    >
      {children}

      {!reduce && armed && (
        <motion.div
          key={shineKey}
          aria-hidden
          style={{
            position: "absolute",
            inset: "-20%",
            pointerEvents: "none",
            willChange: "transform, opacity",
            background:
              "linear-gradient(120deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.45) 50%, rgba(255,255,255,0) 70%)",
          }}
          initial={{ x: "-150%", opacity: 0, rotate: 180 }}
          animate={{ x: "150%", opacity: [0, 1, 0] }}
          transition={{ duration: sweep, ease: "linear" }}
        />
      )}
    </div>
  );
}
